export const enum UltrabufEntries {
    CommandData = 16,
    Revision = 8237,
    CTSlide = 8239,
    MapOp = 8525,
    EGChunkData = 8528,
    MutationTransformRequest = 8536,
    MutationTransformResponse = 8541,
    TransformRequest = 8544,
    TransformResponse = 8551,
}
